module.exports = __webpack_public_path__ + "img/51_29.52454508.png";